<template>
  <div class="producer-add common-page">
    <!-- 面包屑 -->
    <a-breadcrumb>
      <a-breadcrumb-item>生产者管理</a-breadcrumb-item>
      <a-breadcrumb-item>添加生产者</a-breadcrumb-item>
    </a-breadcrumb>

    <section class="common-box">
      <div class="common-box-title">添加生产者</div>
      <div class="common-box-body">
        <a-form :form="form" style="width:600px;">
          <!-- 是否允许生产 -->
          <a-form-item label="是否允许生产" v-bind="formItemLayout">
            <a-radio-group
              placeholder="请选择是否允许生产"
              v-decorator="[ 
                'enabled',
                {
                  rules: [
                    { required: true, message: '请选择是否允许生产' }
                  ],
                  initialValue: true
                },
              ]"
            >
              <a-radio :value="true">是</a-radio>
              <a-radio :value="false">否</a-radio>
            </a-radio-group>
          </a-form-item>

          <!-- 用户名 -->
          <a-form-item label="生产者账号" v-bind="formItemLayout">
            <a-input
              placeholder="请输入生产者账号"
              maxlength="64"
              v-decorator="[ 
                'username',
                {
                  rules: [
                    { required: true, message: '请输入用户名', whitespace: true }
                  ],
                }
              ]"
            />
          </a-form-item>

          <!-- 密码 -->
          <a-form-item label="密码" extra="密码必须包含字母和数字，长度在6~20位之间" v-bind="formItemLayout">
            <a-input-password
              placeholder="请输入密码"
              v-decorator="[ 
                'password',
                  {
                    rules: [
                      {
                        required: true, message: '请输入密码',
                      },
                      {
                       pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z_]{6,20}$/, message: '密码格式错误'
                      }
                    ],
                    validateTrigger:'blur'
                  }
                ]"
            />
          </a-form-item>

          <!-- 生产者姓名 -->
          <a-form-item label="生产者姓名" v-bind="formItemLayout">
            <a-input
              placeholder="请输入生产者姓名"
              maxlength="64"
              v-decorator="[ 
                'name',
                {
                  rules: [
                    { required: true, message: '请输入生产者姓名', whitespace: true }
                  ],
                }
              ]"
            />
          </a-form-item>

          <!-- 公司名称 -->
          <a-form-item label="公司名称" v-bind="formItemLayout">
            <a-input
              placeholder="请输入公司名称"
              maxlength="64"
              v-decorator="[ 
                'companyName',
                {
                  rules: [],
                }
              ]"
            />
          </a-form-item>

          <!-- 公司英文名称 -->
          <a-form-item label="公司英文名称" v-bind="formItemLayout">
            <a-input
              placeholder="请输入公司英文名称"
              maxlength="64"
              v-decorator="[ 
                'companyName_en',
                {
                  rules: [],
                }
              ]"
            />
          </a-form-item>

          <!-- 手机号 -->
          <a-form-item label="手机号" v-bind="formItemLayout">
            <a-input
              placeholder="请输入手机号"
              v-decorator="[
                  'phone',
                  {
                    rules: [
                      { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误' }
                    ],
                    validateTrigger: 'blur'
                  }
                ]"
            />
          </a-form-item>

          <!-- 地址 -->
          <a-form-item label="地址" v-bind="formItemLayout">
            <a-input
              placeholder="请输入地址"
              maxlength="256"
              v-decorator="[ 'address',
                  {
                    rules: [],
                  }
                ]"
            />
          </a-form-item>

          <!-- 描述 -->
          <a-form-item label="描述" v-bind="formItemLayout">
            <a-textarea
              :rows="4"
              placeholder="请输入描述"
              maxlength="256"
              v-decorator="[ 'description',
                  {
                    rules: [],
                  }
                ]"
            />
          </a-form-item>

          <!-- 提交按钮 -->
          <a-form-item label :wrapper-col="{ offset: 6 }">
            <a-button type="primary" @click="submit" :loading="loading">提交</a-button>
          </a-form-item>
        </a-form>
      </div>
    </section>
  </div>
</template>

<script>
import { addProducer } from '../api/api'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 }
  }
}

export default {
  name: 'producer-add',

  data() {
    return {
      form: this.$form.createForm(this),
      formItemLayout,
      loading: false
    }
  },

  methods: {
    submit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          addProducer(values).then(res => {
            if (res.error.code === 0) {
              this.form.resetFields()
              this.$message.success('添加成功')
            }
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.producer-add {
}
</style>